import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SidenavMenuBlock } from '@iot-platform/models/i4b';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationTreeService {
  public httpClient: HttpClient = inject(HttpClient);

  getNavigationTree(): Observable<SidenavMenuBlock[]> {
    return this.httpClient.get<SidenavMenuBlock[]>('assets/data/navigation-tree.json');
  }
}
